// extracted by mini-css-extract-plugin
export var navbarSubLink = "K_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "K_wd d_f0 d_dB";
export var subPageLink = "K_gf d_gf";
export var burger = "K_xr";
export var sublinkSize = "K_xs";
export var linkSize = "K_xt";
export var Link = "K_sJ s_sJ s_r2 s_sm";